import { api } from './index';

export const postJob = (data, token) =>
  api.post('jobs', data, {
    headers: { Authorization: token }
  });

export default {
  postJob
};
